/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Standards_Preset_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_cancel = /** @type {((inputs?: Standards_Preset_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancel")
	return /** @type {LocalizedString} */ ("Cancel")
});